export const BASE_URL = "https://admin.fabricare.app";
export const API_BASE_URL = BASE_URL + "/api";
export const TIMEOUT = 5000;
export const MAX_RETRIES = 3;
export const DATE_FORMAT = "YYYY-MM-DD";
export const CURRENCY = "USD";

export const DB_TOKEN = "DB_TOKEN";
export const DB_LOGGED_IN_PROFILE = "DB_LOGGED_IN_PROFILE";
